import { render, staticRenderFns } from "./Parallax2.vue?vue&type=template&id=1a5732a7&"
import script from "./Parallax2.ts?vue&type=script&lang=ts&"
export * from "./Parallax2.ts?vue&type=script&lang=ts&"
import style0 from "./Parallax2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports